module.exports = __webpack_public_path__ + "static/media/Hospital.60340f84.png";